import { navigate as navigateToHash } from "wouter-preact/use-hash-location";
import { setDrawerNavOpen } from "./store/browser_var.ts";
import type { TargetedMouseEvent } from "preact";

export const navigate = navigateToHash;

export const normalizeAppRoute = (redirectTo: unknown) => {
    const raw = typeof redirectTo === "string" ? redirectTo.trim() : "";
    if (!raw) return "/overview";

    let candidate = raw;
    try {
        if (/^https?:\/\//i.test(candidate)) {
            const u = new URL(candidate);
            candidate = u.hash ? u.hash.slice(1) : `${u.pathname}${u.search}`;
        }
    } catch {
    }

    const hashIndex = candidate.indexOf("#");
    if (hashIndex >= 0) {
        candidate = candidate.slice(hashIndex + 1);
    }
    if (candidate.startsWith("!")) {
        candidate = candidate.slice(1);
    }
    if (!candidate.startsWith("/")) {
        candidate = `/${candidate}`;
    }

    if (candidate === "/login") return "/overview";
    if (candidate.includes("/static/") || candidate.includes("index.html") || candidate.endsWith(".html")) return "/overview";
    return candidate;
};

export const gotoLoginPage = (redirectTo: string) => {
    navigate("/login", { replace: false, state: { goto: normalizeAppRoute(redirectTo) } });
};

/**
 * 用于HTMLElement的onClick回调，会读取事件对象的data-href属性，然后跳转到指定路径。
 */
export const onClickGotoHandler = (evt: TargetedMouseEvent<HTMLElement>) => {
    // Use currentTarget to get the element the listener is attached to (which has the data-href)
    // Fallback to searching up the tree from target if currentTarget is somehow not what we expect (defensive)
    const target = (evt.currentTarget as HTMLElement) || (evt.target as HTMLElement);
    const element = target.closest('[data-href]') as HTMLElement | null;
    const location = element?.dataset["href"] ?? null;
    
    if (location) {
        evt.preventDefault();
        setDrawerNavOpen(false);
        const normalize = (path: string) => path === "/" ? "/overview" : path.split("?")[0];
        const current = window.location.hash.slice(1) || "/";
        if (normalize(current) === normalize(location)) {
            window.dispatchEvent(new Event("farpov:page-refresh"));
            return;
        }
        navigateToHash(location, { replace: false });
    }
};
